function Home() {

    return <div></div>
}

export default Home;